<div
    *ngIf="visible"
    class="fixed lg:sticky top-0 bottom-0 lg:left-full w-full sm:w-96 lg:w-16 lg:h-screen lg:shadow">
    <div
        [ngClass]="{'-translate-x-full sm:-translate-x-96 lg:-translate-x-80 shadow': opened, 'translate-x-0': !opened}"
        class="flex flex-col w-full sm:w-96 h-full transition-transform duration-400 ease-drawer bg-card">

        <!-- Header -->
        <div
            (click)="toggle()"
            class="quick-chat-header flex flex-0 items-center justify-start cursor-pointer">
            <div class="flex flex-auto items-center justify-center">
                <div class="relative flex flex-0 items-center justify-center w-16">
                    <mat-icon
                        [svgIcon]="'heroicons_outline:chat-alt-2'"
                        class="icon-size-6"></mat-icon>
                    <!-- Unread badge (visible on the collapsed bar as well) -->
                    <span
                        *ngIf="totalUnread > 0"
                        class="absolute top-2 right-2.5 flex h-5 min-w-5 items-center justify-center rounded-full bg-primary px-1 text-xs font-semibold text-white ring-2 ring-card">
                        {{ totalUnread > 99 ? '99+' : totalUnread }}
                    </span>
                </div>
                <div class="text-lg font-medium text-secondary">Team Chat</div>
                <button
                    class="ml-auto mr-4"
                    mat-icon-button>
                    <mat-icon [svgIcon]="'heroicons_outline:x'"></mat-icon>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="flex flex-auto flex-col border-t overflow-hidden">

            <!-- Chat list (real team chats with presence + unread) -->
            <div
                [fuseScrollbarOptions]="{wheelPropagation: false}"
                class="flex-auto overflow-y-auto overscroll-y-contain"
                fuseScrollbar>
                <ng-container *ngFor="let chat of chats; trackBy: trackByFn">
                    <div
                        (click)="openChat(chat)"
                        class="flex cursor-pointer items-center py-3 hover:bg-gray-100 dark:hover:bg-hover">

                        <!-- Avatar (sits inside the collapsed 64px strip) -->
                        <div class="flex w-16 flex-0 justify-center">
                            <div class="relative h-9 w-9">
                                <img
                                    *ngIf="displayAvatar(chat)"
                                    [alt]="displayName(chat)"
                                    [src]="displayAvatar(chat)"
                                    class="h-full w-full rounded-full object-cover">
                                <div
                                    *ngIf="!displayAvatar(chat)"
                                    class="flex h-full w-full items-center justify-center rounded-full text-md uppercase bg-gradient-to-br from-primary-100 to-cyan-100 text-primary-800 dark:from-gray-700 dark:to-gray-800 dark:text-gray-200">
                                    {{ displayName(chat).charAt(0) }}
                                </div>
                                <!-- Presence (direct chats) -->
                                <span
                                    *ngIf="chat.type === 'direct'"
                                    [ngClass]="presenceDotClass(chat)"
                                    class="absolute -top-0.5 -right-0.5 h-3 w-3 rounded-full ring-2 ring-card dark:ring-gray-900"></span>
                                <!-- Unread count -->
                                <span
                                    *ngIf="unreadOf(chat) > 0"
                                    class="absolute -bottom-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-semibold text-white ring-2 ring-card dark:ring-gray-900">
                                    {{ unreadOf(chat) }}
                                </span>
                            </div>
                        </div>

                        <!-- Texts -->
                        <div class="min-w-0 flex-auto pr-4">
                            <div class="flex items-center gap-1.5">
                                <span class="truncate font-medium leading-5">{{ displayName(chat) }}</span>
                                <span
                                    *ngIf="chat.type === 'ticket' && chat.cardRef?.boardTitle"
                                    class="flex-0 max-w-[45%] truncate text-[11px] text-secondary">{{ chat.cardRef.boardTitle }}</span>
                                <span
                                    *ngIf="chat.type === 'group'"
                                    class="flex-0 rounded bg-cyan-50 px-1 py-0.5 text-[10px] text-cyan-700 dark:bg-cyan-900/30 dark:text-cyan-300">Gruppe</span>
                                <span
                                    *ngIf="lastMessageDate(chat)"
                                    class="ml-auto flex-0 text-xs text-secondary">{{ lastMessageDate(chat) | date:'HH:mm' }}</span>
                            </div>
                            <div
                                [class.font-medium]="unreadOf(chat) > 0"
                                [class.text-primary]="unreadOf(chat) > 0"
                                class="text-secondary truncate text-sm leading-5">
                                {{ chat.lastMessage || 'Neue Unterhaltung' }}
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Empty state -->
                <div
                    *ngIf="!chats?.length"
                    class="flex flex-col items-center justify-center px-6 py-12 text-center">
                    <mat-icon
                        [svgIcon]="'heroicons_outline:chat-alt-2'"
                        class="icon-size-12 text-hint"></mat-icon>
                    <div class="mt-3 text-secondary">Noch keine Gespräche — starte den ersten Chat mit deinem Team.
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="flex flex-0 items-center justify-center border-t p-3">
                <button
                    (click)="openFullChat()"
                    class="fuse-mat-button-small"
                    color="primary"
                    mat-stroked-button>
                    <mat-icon
                        [svgIcon]="'heroicons_outline:arrows-expand'"
                        class="icon-size-4"></mat-icon>
                    <span class="ml-2">Team Chat öffnen</span>
                </button>
            </div>
        </div>
    </div>
</div>
